import { CommonHelperFunctions, ScreenDesignDocumentDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class ScreenDesignDocumentService {
  public static async Create(screenDesignDocument: ScreenDesignDocumentDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<ScreenDesignDocumentDto, AxiosResponse>(
        `${backendUrl}/documents/create`,
        screenDesignDocument
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Update(obj: ScreenDesignDocumentDto): Promise<AxiosResponse> {
    try {
      return await Axios.put<ScreenDesignDocumentDto, AxiosResponse>(`${backendUrl}/documents/update`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Delete(id: string): Promise<boolean> {
    try {
      await Axios.delete<null>(`${backendUrl}/documents/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async GetAllByScreenDesignId(id: string): Promise<AxiosResponse<ScreenDesignDocumentDto[]>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/documents/getallbyscreendesignid/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
